import { Commit } from "vuex";
import { http } from "../../plugins/axios";

export interface InjuryState {}

const state = (): InjuryState => ({});

const mutations = {};

const getters = {};

const actions = {
  async createInjuryApplication({ commit }: { commit: Commit }, data: any) {
    const endpoint = "/application/injury";

    const res = await http.post(endpoint, data);

    return res.data;
  },
  async getInjuryTypes() {
    const endpoint = "/application/injury/types";

    const res = await http.get(endpoint);

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
